import { rgb, StandardFonts } from 'pdf-lib';

export const vtcPdf = async (pdfDoc, data) => {
  // Replace [name]
  const page = pdfDoc.getPages()[0];
  const { width, height } = page.getSize();

  const font = await pdfDoc.embedFont(StandardFonts.Helvetica, {
    subset: true,
    features: { liga: false },
  });

  page.drawRectangle({
    x: 72, // X position of the background
    y: height - 346, // Y position of the background
    width: width - 140, // Width of the background box (adjust as needed)
    height: 100, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });
  const vtc = `This Technology allows Amazon, its affiliates, Technology providers, contractors, and your employer to gather information that helps Amazon and your employer improve the safety and quality of the delivery experience and to protect Delivery Associates, including to alert them when driving distractions are presented. You can find additional information regarding the collection, use, storage, and retention of the information collected by the Technology in the Privacy Policy for Vehicle Camera Technology, available in the ${data.DSP_TRADENAME}’s Employee Handbook (“Handbook”), which you can always access by requesting a copy from the ${data.DSP_TRADENAME}’s Owner or Human Resources Department.
`;
  page.drawText(vtc, {
    x: 72, // X position of the placeholder
    y: height - 255, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 14,
    font,
    maxWidth: width / 1.3,

    // letterSpacing: 0.5,
  });
  /////

  page.drawText(data.SUFFIX + data.NAME, {
    x: 72, // X position of the placeholder
    y: height - 655, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 15,
  });
  page.drawText(data.DATE, {
    x: 72, // X position of the placeholder
    y: height - 700, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 15,
  });

  // //////

  if (data.SIGNATURE) {
    data.SIGNATURE.forEach((pathString) => {
      page.drawSvgPath(pathString, {
        x: 72,
        y: height - 550,
        // color,
        // borderColor: color,
        borderWidth: 5,
        scale: 0.3,
      });
    });
  }
};
